
import { Assessment } from '@/types/assessment';
import { getAssessmentById, updateAssessment, publishAssessment } from '@/services/assessment';

export async function fetchAssessment(id: string): Promise<Assessment | null> {
  try {
    return await getAssessmentById(id);
  } catch (error) {
    console.error('Error fetching assessment:', error);
    return null;
  }
}

export async function saveAssessmentSettings(
  id: string,
  data: Partial<Assessment>
): Promise<Assessment | null> {
  // Let errors bubble up so the UI can show a proper toast
  return await updateAssessment(id, data);
}

export async function saveAssessmentContent(
  id: string,
  data: Partial<Assessment>
): Promise<Assessment | null> {
  // Let errors bubble up so the UI can show a proper toast
  return await updateAssessment(id, data);
}

export async function publishAssessmentToLive(
  id: string
): Promise<Assessment | null> {
  // Let errors bubble up so the UI can show a proper toast
  return await publishAssessment(id);
}
